module.exports = __webpack_public_path__ + "img/blood-sample-white.2b2277fd.png";